export default __webpack_public_path__ + "ec61762cda6d86f02ffb1aecb4e3c1fb.png";